<template>
  <span class="font-bold"> Password Policies</span>
  <ul class="password-rules" aria-live="polite">
    <li
      v-for="rule in rules"
      :key="rule.id"
      :class="rule.passed ? 'passed' : (showErrors ? 'failed' : '')"
    >
      <i class="material-icons">{{ rule.passed ? "check_circle" : "radio_button_unchecked" }}</i>
      {{ rule.label }}
    </li>
  </ul>
</template>

<script>
import { checkPassword } from "@/passwordPolicy.js";

// Live checklist of the password policy for the given password
export default {
  name: "PasswordRules",
  props: {
    password: { type: String, default: "" },
    // Mark unmet rules red, e.g. after the user tried to submit
    showErrors: { type: Boolean, default: false },
    // When given, also checks the new password differs from it
    currentPassword: { type: String, default: undefined },
  },
  computed: {
    rules() {
      return checkPassword(this.password, { currentPassword: this.currentPassword });
    },
  },
};
</script>

<style scoped>
.password-rules {
  list-style: none;
  padding: 0;
  margin: 4px 0 12px;
  font-size: 12px;
  color: #888;
}
.password-rules li {
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 20px;
}
.password-rules .material-icons {
  font-size: 16px;
}
/* App primary (same as .col-ghipss / .btn-ghipss) */
.password-rules .passed {
  color: #075084;
}
.password-rules .failed {
  color: #f44336;
}
</style>
